import { Preference, PreferenceKey } from "types";
import { SelectionState } from "../hooks/useSelection";

export enum DashboardMode {
    LIST = "list",
    DAY = "day",
    WEEK = "week",
    MONTH = "month",
    EQUIPMENT = "equipment",
    TABLE = "table",
    MERCHANDISE = "merchandise",
}

export enum DashboardScope {
    RESERVED = "reserved",
    AVAILABLE = "available",
    WAITLIST = "waitlist",
    ALL = "all",
    ASSIGNED = "assigned",
}

export enum DashboardContext {
    RESERVED = "dashboard_reserved",
    AVAILABLE = "dashboard_available",
    WAITLIST = "dashboard_waitlist",
    EQUIPMENT = "dashboard_equipment",
    ALL = "dashboard_all",
}

export enum DashboardCustomizationPreference {
    AVAILABILITY = "availability",
    LISTING = "listing",
}

export enum DashboardGroupBy {
    NONE = "none",
    PRODUCT = "product",
    ARRIVAL_TIME = "arrivalTime",
    EVENT = "event",
    EQUIPMENT = "equipment",
    GUIDE = "guide",
    PICKUP = "pickup",
}

export enum DashboardGroupId {
    NO_TIME = "No Fixed Times",
    NO_PRODUCT = "No Product",
    NO_EQUIPMENT = "No Equipment",
    NO_GUIDE = "No Guide",
    NO_PICKUP = "No Pickup",
    OTHER = "Other",
}
export interface ResourceSelectionState extends SelectionState {
    showUnassigned?: boolean;
}

export interface DashboardFilter {
    products: SelectionState;
    guide: ResourceSelectionState;
    resource: ResourceSelectionState;
    scope: DashboardScope;
    mode: DashboardMode;
    groupBy: DashboardGroupBy;
}

export interface DashboardRosterColumnsConfig {
    id: ID;
    name?: string;
    sort: "desc" | "asc" | null;
    hide: boolean | null;
    pinned: string | null;
    productId?: ID;
}

export interface DashboardColorPreference extends Preference<DashboardColorPreferenceValue> {
    key: PreferenceKey.XOLA_SELLER_DASHBOARD_COLORS;
}

interface DashboardColorPreferenceValue {
    background: "listing" | "availability" | "none";
    sidebar: "listing" | "availability" | "none";
    experiences?: { [key: ID]: string };
}

export interface DashboardPreference extends Preference<DashboardPreferenceValue> {
    key: PreferenceKey.XOLA_SELLER_DASHBOARD;
}

export interface DashboardRosterPreference extends Preference<DashboardRosterPreferenceValue> {
    key: PreferenceKey.XOLA_SELLER_ROSTER;
}

interface DashboardPreferenceValue {
    configurations: ViewConfiguration[];
}

interface DashboardRosterPreferenceValue {
    configurations: RosterViewConfiguration[];
}

export interface ViewConfiguration {
    id: number;
    name: string;
    favourite: boolean;
    filter: DashboardFilter;
    displayOptions?: DashboardDisplayOptions;
}

export interface RosterViewConfiguration {
    id: number | string;
    name: string;
    favourite: boolean;
    columns: DashboardRosterColumnsConfig[];
    // Equipment-based experiences only: which roster sub-views are shown. Default both on.
    showAttendeeView?: boolean;
    showEquipmentView?: boolean;
}

export interface DashboardDisplayOptions {
    expandAllRows: boolean;
    showSummaryRows: boolean;
}
